import { GtmSetupConsent } from "./GtmSetupConsent";

new GtmSetupConsent().Init();
